import { configureStore } from "@reduxjs/toolkit";
import appSpinnerReducer from "./slices/appSpinnerSlice";
import questionnaireReducer from "./slices/questionnaireSlice";
import issbRoundReducer from "./slices/issbRoundSlice";
import adminViewReducer from "./slices/adminViewSlice";

export default configureStore({
  reducer: {
    appSpinner: appSpinnerReducer,
	// TODO replace with url path or parameters for questionnaire and round
	// So we can have shareable deep links to specific questionnaires and rounds
	// and support browser tabs and browser history
    questionnaire: questionnaireReducer,
    issbRound: issbRoundReducer,
    adminView: adminViewReducer
  }
});